import { css, jsx } from '@emotion/core';
import { Input } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { passwordValidationPattern } from '@/src/auth/utils';
import Form from '@/src/shared/components/Form';
import { bp, colors } from '@/styles';

const styles = {
  inputContainer: css`
    width: 100%;
    margin: 1.6rem 0;
    @media ${bp.md} {
      max-width: 36.5rem;
    }
    .ant-input {
      border-width: 1px;
      border-style: solid;
      border-color: rgb(218, 217, 215);
    }
  `,

  passwordRequirements: css`
    padding-left: 1.75rem;
    line-height: 2rem;
  `,
};

const TextInput = ({ form, info, step, currentInfo, key, onChange }) => {
  const [isPasswordValid, setPasswordValid] = useState(false);

  const { register } = useSelector(state => state);

  const handleConfirmBlur = e => {
    const {
      target: { value },
    } = e;
    setPasswordValid(isPasswordValid || !!value);
  };

  const validateFirstPassword = (rule, value, callback) => {
    if (value && value !== form.getFieldValue('Password')) {
      callback('Enter the same password.');
    } else {
      callback();
    }
  };

  const validateConfirmPassword = (rule, value, callback) => {
    if (value && isPasswordValid) {
      form.validateFields(['ConfirmPassword'], { force: true });
    }
    callback();
  };

  return (
    <>
      <div key={key} css={styles.inputContainer}>
        <Form.Item label="Password" hasFeedback>
          {form.getFieldDecorator('Password', {
            initialValue: register['Password'],
            rules: [
              {
                required: true,
                message: 'Enter password.',
              },
              {
                validator: validateConfirmPassword,
              },
              passwordValidationPattern(),
            ],
          })(
            <Input.Password
              visibilityToggle={false}
              onChange={e => {
                onChange('Password', e);
              }}
              onPaste={e => {
                e.preventDefault();
                return false;
              }}
              size="large"
            />
          )}
        </Form.Item>
      </div>
      <div key={key} css={styles.inputContainer}>
        <Form.Item label="Confirm Password" hasFeedback>
          {form.getFieldDecorator('ConfirmPassword', {
            initialValue: register['ConfirmPassword'],
            rules: [
              {
                required: true,
                message: 'Please confirm your password.',
              },
              {
                validator: validateFirstPassword,
              },
              passwordValidationPattern(),
            ],
          })(
            <Input.Password
              visibilityToggle={false}
              onChange={e => {
                onChange('ConfirmPassword', e);
              }}
              onPaste={e => {
                e.preventDefault();
                return false;
              }}
              size="large"
              onBlur={handleConfirmBlur}
            />
          )}
          <div>
            Password requirements:
            <ul css={styles.passwordRequirements}>
              <li>At least 8 characters</li>
              <li>1 lowercase and 1 uppercase</li>
              <li>1 special character</li>
            </ul>
          </div>
        </Form.Item>
      </div>
    </>
  );
};

TextInput.defaultProps = {
  formOverrides: {},
  onChange: () => {},
};
export default TextInput;
